import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalService } from '../../services/modal.service';
import { PopulationService } from '../../services/population.service';
import { ToastService } from '../../services/toast.service';
import { Browser } from '@capacitor/browser';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-insured-export-modal',
  templateUrl: './insured-export-modal.component.html',
  styleUrls: ['./insured-export-modal.component.scss'],
})
export class InsuredExportModalComponent  implements OnInit {
  exportForm = new FormGroup({
    format: new FormControl('xlsx'),
    fields: new FormGroup({
      id: new FormControl(true),
      firstname: new FormControl(true),
      lastname: new FormControl(true),
      coverage: new FormControl(true),
      contract: new FormControl(false),
      totalPremium: new FormControl(false),
      startDate: new FormControl(false),
      endDate: new FormControl(false),
      beneficiariesCount: new FormControl(false),
      beneficiaryType: new FormControl(false),
    })
  })
  loading: boolean = false;
  env = environment;

  constructor(
    private modalService: ModalService,
    private populationService: PopulationService,
    private toastService: ToastService,
  ) { }

  ngOnInit() {}

  close() {
    this.modalService.closeAll();
  }

  export() {
    if (this.exportForm.invalid || this.loading) {
      return;
    }
    this.loading = true;
    // Get the form values
    const formValues = this.exportForm.value;
    // Get the format
    const format: 'xlsx' | 'pdf' = formValues.format as 'xlsx' | 'pdf';
    // Get the fields that are checked
    const fields = Object.entries(formValues.fields).filter(entry => {
      return entry[1] === true;
    }).map(key => key[0]);

    // Call the export service
    this.populationService.exportMembers(format, fields).then((res) => {
      // Open the file in a new tab
      console.log(res.url);
      Browser.open({url: res.url, windowName: '_blank'});
      this.loading = false;
      this.close();
    }).catch(() => {
      this.toastService.open({
        message: 'Une erreur est survenue lors de l\'export',
        type: 'error',
        position: 'bottom',
        header: 'Erreur',
      });
      this.loading = false;
    });
  }
}
